import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@mesterplan/auth-react';
import { idpEnabled } from '@/lib/idp';
import { adminApi } from './adminClient';

function VerifiedLink() {
  const { status, user } = useAuth();
  const session = useQuery({
    queryKey: ['platform-admin-entry', user?.id],
    queryFn: () => adminApi.session(),
    enabled: status === 'authenticated',
    retry: false,
    staleTime: 0,
    refetchInterval: 30_000,
    gcTime: 0,
  });
  return status === 'authenticated' && session.data?.ok
    ? <Link to="/admin" className="block rounded-lg px-3 py-2 text-sm font-semibold text-primary">Platformadministration</Link>
    : null;
}

export function PlatformAdminLink() { return idpEnabled ? <VerifiedLink /> : null; }
